import React from 'react';
import classNames from 'classnames';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'secondary';
  className?: string;
}

export const Badge = ({
  children,
  variant = 'default',
  className,
}: BadgeProps) => {
  return (
    <div
      className={classNames(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors',
        variant === 'default' &&
          'border-transparent bg-black text-white hover:bg-gray-800',
        variant === 'secondary' &&
          'border-transparent bg-neutral-100 text-neutral-900 hover:bg-neutral-200',
        className,
      )}
    >
      {children}
    </div>
  );
};
